/**
 * @typedef {'JobRequest' | 'RetrieveJobResults' | 'DeleteJob'} JobManagerRequestTypeOptions
 * @type {{
 *    JOB_REQUEST: "JobRequest",
 *    RETRIEVE_JOB_RESULTS: "RetrieveJobResults",
 *    DELETE_JOB: "DeleteJob"
 * }}
 */
export const JobManagerRequestTypes = {
    JOB_REQUEST: 'JobRequest',
    RETRIEVE_JOB_RESULTS: 'RetrieveJobResults',
    DELETE_JOB: 'DeleteJob',
};

/**
 * @typedef {'JobCreated' | 'JobResults' | 'JobDeleted'} JobManagerResponseTypeOptions
 * @type {{
 *    JOB_CREATED: "JobCreated",
 *    JOB_RESULTS: "JobResults",
 *    JOB_DELETED: "JobDeleted"
 * }}
 */
export const JobManagerResponseTypes = {
    JOB_CREATED: 'JobCreated',
    JOB_RESULTS: 'JobResults',
    JOB_DELETED: 'JobDeleted',
};

export function makeJobRequest({
    jobtype, jobrequest, stash={}, requestmeta,
}) {
    return {
        type: JobManagerRequestTypes.JOB_REQUEST,
        jobtype,
        jobrequest,
        stash,
        requestmeta: JSON.stringify(requestmeta),
    };
}
